import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedServiceService {

  private _isDestinatarioPresente = new BehaviorSubject<boolean>(false);

  // Observable per i componenti che vogliono "ascoltare" il cambiamento
  public isDestinatarioPresente$ = this._isDestinatarioPresente.asObservable();

  // Metodo per aggiornare lo stato
  setDestinatarioPresente(valore: boolean) {
    this._isDestinatarioPresente.next(valore);
  }

}
